export type TSeniorityLevel = {
  code: string;
  title: string;
  description: string;
};

export const SENIORITY_LEVELS: TSeniorityLevel[] = [
  { code: 'L1', title: 'Intern', description: 'Bounded, supervised tasks' },
  { code: 'L2', title: 'Entry', description: 'Own tasks, defined parameters' },
  { code: 'L3', title: 'Junior', description: 'Own tasks, reduced supervision' },
  { code: 'L4', title: 'Mid', description: 'Owns a project end-to-end in a team' },
  { code: 'L5', title: 'Senior', description: 'Complex / ambiguous work; team-wide influence' },
  { code: 'L6', title: 'Lead', description: 'Owner of a defined area / specialty beyond a single team' },
  { code: 'L7', title: 'Manager', description: 'Across multiple teams or a whole function' },
  { code: 'L8', title: 'Director', description: 'An org or several functions' },
  { code: 'L9', title: 'Executive', description: 'The enterprise / top of a ladder' },
];
